/**
 * Captures the booking token from the URL fragment (`#token=…`) and immediately scrubs it from the
 * address bar and browser history.
 *
 * This module is imported FIRST in `main.tsx` so `captureBookingToken()` runs before App Insights
 * initializes and before React renders. That guarantees the token never appears in a page-view URL,
 * a telemetry event, the browser history entry, the visible address bar, or the `Referer` header —
 * it is lifted into memory and the URL is cleaned in the same tick.
 */
function captureBookingToken(): string | null {
  if (typeof window === 'undefined') return null

  const hash = window.location.hash
  if (!hash) return null

  const token = new URLSearchParams(hash.replace(/^#/, '')).get('token')
  if (token) {
    // replaceState (not pushState) so the tokenized URL is removed from history, not just hidden —
    // back/forward and history sync can't surface it.
    window.history.replaceState(null, '', window.location.pathname + window.location.search)
  }
  return token
}

export const bookingToken: string | null = captureBookingToken()
